import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { Button, Form, Message, Modal } from 'semantic-ui-react'

export default function SendTestEmailSurveyModal({
  modalOpen,
  handleCloseModal,
  handleSendTestEmailSurvey,
  receiverEmails,
  setReceiverEmails,
  isSendTestEmailSurveyButtonLoading,
  inputEmailError = false,
  inputMaxEmailError = false,
  showDefaultLanguageWarning = false,
}) {
  const hiddenSubmitButtonRef = useRef(null)
  function onSubmit(e) {
    e.preventDefault()
    handleSendTestEmailSurvey()
  }
  return (
    <Modal size={'tiny'} open={modalOpen} onClose={handleCloseModal}>
      <Modal.Header>Send a test email</Modal.Header>
      <Modal.Content>
        {showDefaultLanguageWarning && (
          <Message warning size="small" className="!mb-3">
            <Message.List>
              <Message.Item>
                To send emails in this language, fill in <b>Subject</b> and <b>From</b>. Otherwise,
                emails send in the default language.
              </Message.Item>
            </Message.List>
          </Message>
        )}
        {inputEmailError && (
          <Message negative>
            <p>Please make sure email addresses are valid and separated by a comma.</p>
          </Message>
        )}
        {inputMaxEmailError && (
          <Message negative>
            <p>You can only send test emails to no more than 10 email addresses.</p>
          </Message>
        )}
        <React.Fragment>
          <Form onSubmit={onSubmit}>
            <Form.Input
              label="Send test to"
              type="text"
              name="email"
              value={receiverEmails}
              onChange={(e) => setReceiverEmails(e.target.value)}
            />
            <button type="submit" hidden ref={hiddenSubmitButtonRef} />
          </Form>
          <p className="mt2 h5 text-grey">Separate multiple email addresses with a comma.</p>
        </React.Fragment>
      </Modal.Content>

      <Modal.Actions>
        <Button onClick={handleCloseModal} content="Cancel" />
        <Button
          type="button"
          primary
          onClick={() => {
            hiddenSubmitButtonRef.current.click()
          }}
          loading={isSendTestEmailSurveyButtonLoading}
          disabled={isSendTestEmailSurveyButtonLoading}
        >
          Send test
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

SendTestEmailSurveyModal.propTypes = {
  modalOpen: PropTypes.bool,
  handleCloseModal: PropTypes.func,
  handleSendTestEmailSurvey: PropTypes.func,
  isSendTestEmailSurveyButtonLoading: PropTypes.bool,
  receiverEmails: PropTypes.string,
  setReceiverEmails: PropTypes.func,
  inputEmailError: PropTypes.bool,
  inputMaxEmailError: PropTypes.bool,
  showDefaultLanguageWarning: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SendTestEmailSurveyModal/index.js